<template>
  <div v-if="socialContent" :class="className">
    <template v-if="socialContent.contactData">
      <div 
        v-for="(item, index) in socialContent.contactData" 
        :key="index"
        :class="className + '-item'">
        <div :class="className + '-label'" v-if="item.label">{{item.label}}</div>
        <div :class="className + '-value'" v-if="item.value">
          <template v-if="item.format === 'email'">
            <a :href="'mailto:' + item.value">{{item.value}}</a>
          </template>
          <template v-else-if="item.format === 'markdown'">
            <div v-html="parseContent(item.value)"/>
          </template>
          <template v-else>
            {{item.value}}
          </template>
        </div>
      </div>
    </template>
    <template v-if="socialContent.socialMenu">
      <div :class="className + '-item'">
        <div :class="className + '-label'" v-if="socialContent.socialMenu.title">{{socialContent.socialMenu.title}}</div>
        <SocialMenu v-if="socialContent.socialMenu" :id="socialContent.socialMenu.id" :slug="className + '-value'" />
      </div>
    </template>
  </div>
</template>

<script>

import gql from 'graphql-tag'
import marked from 'marked'

import SocialMenu from 'components/Menu.vue'

export default {
  name: 'Social',
  props: [
    'id',
    'className'
  ],
  data() {
    return {
      socialContent: {}
    }
  },
  components: {
    SocialMenu
  },
  apollo: {
    socialContent: {
      query: gql`query Social ($id: ItemId) {
        socialContent(filter: {id: {eq: $id}}) {
          title
          contactData {
            label
            value
            format
          }
          socialMenu {
            title
            id
          }
        }
      }`,
      variables() {
        return {
          id: this.id
        }
      },
      prefetch({route}) {
        return {
          id: route.params.id
        }
      }
    }
  },
  methods: {
    parseContent(content) {
      return marked(content, {sanitize: false});
    }
  }
}
</script>

<style scoped lang="less">

</style>
